import { MAIN_QUESTS_GROUP, appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const chessUniverseQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-wishlist-added",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/chess-universe/ChessUniverseTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-trailer-watched",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-discord-followed",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-discord",
    linkUrl: "https://discord.com/invite/stKjCCuRyt",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Chess Universe on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-twitter-followed",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-twitter",
    linkUrl: "https://x.com/chess_universe",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Join Chess Universe website",
    caption: "Join our massively growing community",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-website-visited",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-website",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-onboarding-completed",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-onboarding",
  },
];

const chessUniverseQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing Chess Universe",
    caption: "Extra Gems for sharing on X",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "9e683073-a784-4a04-b793-49816cd66d4e-recurring-tweet-completed",
    ruleId: "9e683073-a784-4a04-b793-49816cd66d4e-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@chess_universe",
    recurring: true,
    tweetUsername: "@chess_universe",
  },
];

export const chessUniverseQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 50,
    quests: chessUniverseQuestsList,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems by posting to socials",
    },
    totalGemsGranted: 10,
    quests: chessUniverseQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
